import { Link } from "react-router-dom";
import { Mail, MapPin, Phone, ArrowUpRight } from "lucide-react";

const GOOGLE_REVIEWS_URL =
  "https://www.google.com/search?sca_esv=a34ddc620dd62935&rlz=1C5OZZY_enFR1219FR1219&sxsrf=APpeQnt2riNpk_pTrJbhn1UqDTnzaSn1Fg:1782122123241&q=Breizh+Boost+Studio&si=APenkKm7iecQ4G6P-TsbSMFKIQtv3EFIqRAFw-i8uEbk55Z-_yHpA4Hr45a22syT-iVfZIMXXjO83BK0mAy5WtY6ao3gPcuO_o1c6sQDLs3z39ASY773mvM%3D&uds=AJ5uw18zeF8z_P7IQbfeR8tV0KKTVEHQ-UDoyhKZ227l_NENuMs2YDFLKz1BGr_8iOAv4agt6tgYa5rKQfPRmEwobRlCU7t7NGO66tnigRniEAIGPxoTx6E&sa=X&sqi=2&ved=2ahUKEwjtoeigypqVAxUHRqQEHbz7NiYQ3PALegQINBAF";

function GoogleGIcon({ className = "h-7 w-7" }) {
  return (
    <svg viewBox="0 0 48 48" className={className} aria-hidden focusable="false">
      <path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z" />
      <path fill="#FF3D00" d="M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.656 8.337 6.306 14.691z" />
      <path fill="#4CAF50" d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238C29.211 35.091 26.715 36 24 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z" />
      <path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303c-.792 2.237-2.231 4.166-4.094 5.571.001-.001.002-.001.003-.002l6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z" />
    </svg>
  );
}

export default function Footer() {
  return (
    <footer
      className="relative mt-24 border-t border-up-taupe/30 bg-up-sand/60"
      data-testid="site-footer"
    >
      {/* BANDEAU ÉDITORIAL — phrase impactante + mini mockup + CTA */}
      <div
        className="relative overflow-hidden bg-up-brown text-up-offwhite"
        data-testid="footer-editorial"
      >
        <div className="absolute inset-0 grain opacity-60" aria-hidden />
        <div
          className="absolute -top-32 -right-32 h-[28rem] w-[28rem] rounded-full bg-up-sand/10 blur-3xl"
          aria-hidden
        />
        <div
          className="absolute -bottom-24 -left-24 h-[22rem] w-[22rem] rounded-full bg-up-sand/5 blur-3xl"
          aria-hidden
        />

        <div className="relative container-up py-20 md:py-28 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-7 reveal">
            <span className="inline-block text-[11px] tracking-[0.32em] uppercase text-up-sand/80 font-medium">
              On en discute ?
            </span>
            <h2 className="mt-5 font-serif text-[2.25rem] sm:text-4xl md:text-5xl lg:text-[3.25rem] leading-[1.08] tracking-tight !text-up-offwhite">
              Et si on transformait
              <em className="italic font-normal text-up-sand"> votre image ensemble</em>&nbsp;?
            </h2>
            <p className="mt-6 text-up-sand text-base md:text-lg leading-[1.8] max-w-lg">
              Premier échange gratuit, sans engagement — on prend le temps de
              comprendre votre activité.
            </p>
            <div className="mt-9 flex flex-wrap items-center gap-4">
              <Link
                to="/contact"
                data-testid="footer-editorial-cta"
                className="inline-flex items-center gap-2 rounded-full bg-up-sand text-up-brown px-9 py-4 text-sm font-medium tracking-wide transition-all duration-500 hover:-translate-y-0.5 hover:bg-up-offwhite hover:shadow-[0_24px_50px_-20px_rgba(220,198,163,0.6)]"
              >
                Prendre rendez-vous
                <ArrowUpRight className="h-4 w-4" />
              </Link>
              <a
                href="mailto:breizh.boost.studio@gmail.com"
                className="inline-flex items-center gap-2 text-sm text-up-sand hover:text-up-offwhite transition-colors"
              >
                <Mail className="h-4 w-4" />
                breizh.boost.studio@gmail.com
              </a>
            </div>
          </div>

          {/* Mini composition mockup */}
          <div className="lg:col-span-5 reveal hidden md:block" style={{ transitionDelay: "180ms" }}>
            <div className="relative mx-auto max-w-sm">
              {/* Mockup site */}
              <div
                className="relative rounded-2xl overflow-hidden ring-1 ring-up-sand/30 shadow-[0_30px_60px_-25px_rgba(0,0,0,0.5)] transform rotate-[-3deg] transition-transform duration-700 hover:rotate-0"
                style={{ background: "#FAF4EA" }}
              >
                <div className="flex items-center gap-1.5 px-3 py-2 border-b border-up-taupe/30 bg-up-sand-soft">
                  <span className="h-2 w-2 rounded-full bg-[#E3A292]" />
                  <span className="h-2 w-2 rounded-full bg-[#E6CB8A]" />
                  <span className="h-2 w-2 rounded-full bg-[#9BB89B]" />
                </div>
                <img
                  src="https://customer-assets.emergentagent.com/job_breizh-boost/artifacts/c9hkfep9_1.png"
                  alt=""
                  className="block w-full h-auto"
                />
              </div>
              {/* Carte flottante logo */}
              <div
                className="absolute -bottom-6 -left-4 sm:-left-8 w-24 sm:w-28 rounded-2xl overflow-hidden ring-1 ring-up-sand/30 shadow-[0_24px_50px_-20px_rgba(0,0,0,0.6)] transform rotate-[5deg] transition-transform duration-700 hover:rotate-0"
                style={{ background: "#FAF4EA" }}
                aria-hidden
              >
                <img
                  src="https://customer-assets.emergentagent.com/job_breizh-boost/artifacts/il1krkeh_LOGO%201%20-%20test.png"
                  alt=""
                  className="block w-full h-auto p-2"
                />
              </div>
              {/* Badge stat */}
              <div
                className="absolute -top-4 -right-2 sm:-right-4 inline-flex items-center gap-2 rounded-full bg-up-offwhite ring-1 ring-up-sand/30 shadow-[0_18px_40px_-15px_rgba(0,0,0,0.5)] px-3 py-1.5 text-[11px] tracking-[0.18em] uppercase text-up-brown"
                aria-hidden
              >
                <MapPin className="h-3 w-3" />
                Bretagne
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* GRILLE FOOTER CLASSIQUE */}
      <div className="container-up py-16 md:py-20 grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5 flex flex-col gap-5">
          <div className="flex items-center gap-4">
            <img
              src="https://customer-assets.emergentagent.com/job_breizh-boost/artifacts/2lsrq7t5_LOGO.jpg"
              alt="Breizh Boost Studio"
              className="h-14 w-14 rounded-full object-cover ring-1 ring-up-taupe/40"
            />
            <span className="font-serif text-2xl text-up-brown">
              Breizh Boost Studio
            </span>
          </div>
          <p className="text-up-muted max-w-sm leading-relaxed">
            Création de sites, visibilité et image pour les entreprises
            bretonnes. Simple. Moderne. Efficace.
          </p>
          <div className="flex items-center gap-4 pt-1">
            <a
              href="https://www.instagram.com/breizh.boost.studio/?hl=fr"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram Breizh Boost Studio"
              data-testid="footer-instagram-link"
              className="inline-flex transition-all duration-300 hover:scale-110 hover:opacity-90"
            >
              <img
                src="https://customer-assets.emergentagent.com/job_breizh-boost/artifacts/1580qcvw_Instagram_Glyph_Gradient.png"
                alt="Instagram Breizh Boost Studio"
                className="h-7 w-7"
              />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61589296417284"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook Breizh Boost Studio"
              data-testid="footer-facebook-link"
              className="inline-flex transition-all duration-300 hover:scale-110 hover:opacity-90"
            >
              <img
                src="https://customer-assets.emergentagent.com/job_breizh-boost/artifacts/dejeqq22_Facebook_Logo_Primary.png"
                alt="Facebook Breizh Boost Studio"
                className="h-7 w-7"
              />
            </a>
            <a
              href={GOOGLE_REVIEWS_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Avis Google Breizh Boost Studio"
              data-testid="footer-google-link"
              className="inline-flex transition-all duration-300 hover:scale-110 hover:opacity-90"
            >
              <GoogleGIcon className="h-7 w-7" />
            </a>
          </div>
          <div className="flex flex-col gap-2 text-sm text-up-brown/80">
            <span className="inline-flex items-center gap-2">
              <MapPin className="h-4 w-4 text-up-muted" /> Bretagne · France
            </span>
            <a
              href="tel:0695977072"
              className="inline-flex items-center gap-2 hover:text-up-brown"
              data-testid="footer-phone-link"
              aria-label="Appeler Breizh Boost Studio"
            >
              <Phone className="h-4 w-4 text-up-muted" />
              Appeler
            </a>
            <a
              href="mailto:breizh.boost.studio@gmail.com"
              className="inline-flex items-center gap-2 hover:text-up-brown"
              data-testid="footer-email-link"
            >
              <Mail className="h-4 w-4 text-up-muted" />
              breizh.boost.studio@gmail.com
            </a>
          </div>
        </div>

        <div className="md:col-span-3 flex flex-col gap-3">
          <h4 className="font-serif text-xl text-up-brown">Navigation</h4>
          <Link to="/" className="text-sm text-up-muted hover:text-up-brown">Accueil</Link>
          <Link to="/services" className="text-sm text-up-muted hover:text-up-brown">Mes services</Link>
          <Link to="/galerie" className="text-sm text-up-muted hover:text-up-brown">Galerie</Link>
          <Link to="/a-propos" className="text-sm text-up-muted hover:text-up-brown">À propos</Link>
          <Link to="/contact" className="text-sm text-up-muted hover:text-up-brown">Contact</Link>
        </div>

        <div className="md:col-span-4 flex flex-col gap-5">
          <h4 className="font-serif text-xl text-up-brown">
            Un coup de boost à votre activité&nbsp;?
          </h4>
          <p className="text-sm text-up-muted leading-relaxed">
            Premier échange découverte de 30 minutes offert — posons les bases
            ensemble.
          </p>
          <Link
            to="/contact"
            className="btn-primary self-start group"
            data-testid="footer-cta-rdv"
          >
            Prendre rendez-vous
            <ArrowUpRight className="h-4 w-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </Link>
        </div>
      </div>

      <div className="border-t border-up-taupe/40">
        <div className="container-up py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs tracking-wide text-up-muted">
          <span>
            © {new Date().getFullYear()} Breizh Boost Studio — Tous droits
            réservés.
          </span>
          <span className="italic font-serif">
            Donnez un coup de boost à votre visibilité.
          </span>
        </div>
      </div>
    </footer>
  );
}
